export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'music',
    name: '音乐',
    description: '用旋律诉说心声，让音符成为你最动人的语言',
    icon: 'ri-music-line',
    articleCount: 128,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20soft%20abstract%20musical%20scene%20with%20floating%20notes%20and%20gentle%20golden%20light%2C%20minimalist%20style%2C%20clean%20cream%20background%2C%20ethereal%20atmosphere%2C%20artistic%20composition%20with%20subtle%20textures&width=400&height=300&seq=cat-music-2026&orientation=landscape',
  },
  {
    slug: 'dance',
    name: '舞蹈',
    description: '用身体诠释艺术，每一个动作都是独特的情感表达',
    icon: 'ri-music-line',
    articleCount: 95,
    imageUrl: 'https://readdy.ai/api/search-image?query=Graceful%20abstract%20dance%20movement%20scene%20with%20flowing%20fabric%20and%20soft%20warm%20lighting%2C%20minimalist%20style%2C%20cream%20background%2C%20ethereal%20atmosphere%2C%20artistic%20composition&width=400&height=300&seq=cat-dance-2026&orientation=landscape',
  },
  {
    slug: 'painting',
    name: '绘画',
    description: '用画笔描绘世界，让色彩成为你独一无二的表达方式',
    icon: 'ri-palette-line',
    articleCount: 156,
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20abstract%20painting%20studio%20scene%20with%20warm%20lighting%20and%20artistic%20tools%2C%20minimalist%20style%2C%20cream%20background%2C%20soft%20textures%2C%20inspirational%20atmosphere&width=400&height=300&seq=cat-painting-2026&orientation=landscape',
  },
  {
    slug: 'writing',
    name: '写作',
    description: '用文字记录生活，让每一个故事都成为照亮他人的光',
    icon: 'ri-quill-pen-line',
    articleCount: 210,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20writing%20desk%20scene%20with%20notebook%20and%20soft%20golden%20light%2C%20minimalist%20style%2C%20cream%20background%2C%20literary%20atmosphere%2C%20clean%20composition&width=400&height=300&seq=cat-writing-2026&orientation=landscape',
  },
  {
    slug: 'photography',
    name: '摄影',
    description: '用镜头捕捉瞬间，让每一帧画面讲述动人的故事',
    icon: 'ri-camera-line',
    articleCount: 182,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20photography%20scene%20with%20vintage%20camera%20and%20warm%20natural%20light%2C%20minimalist%20style%2C%20cream%20background%2C%20artistic%20atmosphere%2C%20soft%20shadows&width=400&height=300&seq=cat-photography-2026&orientation=landscape',
  },
  {
    slug: 'food',
    name: '美食',
    description: '用味蕾探索世界，让每一道菜肴承载你的温暖与记忆',
    icon: 'ri-restaurant-line',
    articleCount: 140,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20culinary%20scene%20with%20artistic%20food%20arrangement%20and%20soft%20golden%20lighting%2C%20minimalist%20style%2C%20cream%20background%2C%20elegant%20composition&width=400&height=300&seq=cat-food-2026&orientation=landscape',
  },
  {
    slug: 'handcraft',
    name: '手工',
    description: '用双手创造美好，让每一件作品凝聚匠心与温度',
    icon: 'ri-scissors-cut-line',
    articleCount: 88,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20abstract%20handcraft%20workshop%20scene%20with%20artistic%20materials%20and%20warm%20natural%20light%2C%20minimalist%20style%2C%20cream%20background%2C%20creative%20atmosphere&width=400&height=300&seq=cat-handcraft-2026&orientation=landscape',
  },
  {
    slug: 'tech',
    name: '科技',
    description: '用创新改变生活，让每一个灵感碰撞出智慧的火花',
    icon: 'ri-computer-line',
    articleCount: 165,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20technology%20scene%20with%20clean%20geometric%20elements%20and%20warm%20ambient%20light%2C%20minimalist%20style%2C%20cream%20background%2C%20innovative%20atmosphere&width=400&height=300&seq=cat-tech-2026&orientation=landscape',
  },
];

export const allCategory: Category = {
  slug: 'all',
  name: '全部',
  description: '浏览所有分类的精彩内容，发现不一样的世界',
  icon: 'ri-apps-line',
  articleCount: 1164,
  imageUrl: '',
};